import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";

import { Grid, TextField } from "@material-ui/core";

@inject("bookingRequestStore", "profileStore")
@withRouter
@observer
class BookerAgencyDetails extends Component {
    render() {
        const booking = this.props.bookingRequestStore.booking;
        if (!booking) return null;
        
        const { createdBy, provider } = booking;

        return (
            <Grid container spacing={8}>
                <Grid item xs={12} lg={6} className="gridBookingForm">
                    <TextField
                        label="Provider / Agency"
                        value={provider || ""}
                        fullWidth
                        InputProps={{
                            readOnly: true
                        }}
                    />
                </Grid>
                <Grid item xs={12} lg={6} className="gridBookingForm">
                    <TextField
                        label="Booking Creator"
                        value={createdBy ? `${createdBy.firstName} ${createdBy.lastName}` : ""}
                        fullWidth
                        InputProps={{
                            readOnly: true
                        }}
                    />
                </Grid>
                <Grid item xs={12} lg={6} className="gridBookingForm">
                    <TextField
                        label="Booking Creator Email"
                        value={createdBy?.email || ""}
                        fullWidth
                        InputProps={{
                            readOnly: true
                        }}
                    />
                </Grid>
                <Grid item xs={12} lg={6} className="gridBookingForm">
                    <TextField
                        label="Booking Creator Phone"
                        value={createdBy?.contactPhone || ""}
                        fullWidth
                        InputProps={{
                            readOnly: true
                        }}
                    />
                </Grid>
            </Grid>
        );
    }
}

export default BookerAgencyDetails;
